import {Table as BaseTabel} from "./Table";
import {useStore} from "./store";

const Table = Object.assign(BaseTabel, {useStore})
export {Table}